import {  Modal } from "@mui/material";
import * as React from "react";
import { FC, useEffect, useState, useRef } from 'react';
import InventoryFormNew from "../Inventory/InventoryFormNew";


const AddItem: FC<any> = (props) => {

    const onClose = () => {
        props.setVisible(false)
    }

    return(
        <Modal
            
            open={props.visible}
            onClose={(event : any, reason:any) => {
                if (reason !== 'backdropClick') {
                    props.setVisible(true)
                }
            }}
        >
          <InventoryFormNew model={true} onClose={onClose}/>
        </Modal>
    )
};
export default AddItem;